import { useEffect, useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { FavouriteTag } from '../../../hooks/filters/interfaces/favourite-value.interface';
import { FilterSelectedValue } from '../../../hooks/filters/interfaces/filter-selected-value.interface';
import {
  useAppFavouriteDefaultTitle,
  useAppFavouriteId,
  useAppFavouriteValue,
} from '../../../hooks/filters/use-app-favourite.hook';
import { useEncodeFilterSelection } from '../../../hooks/filters/use-encode-filter-selection';
import {
  H_ID_PREFIX,
  H_LS_KEY,
  removeFavouteOlderList,
} from '../../../services/get-favourite.service';
import { PATH_TAGS } from '../../../static-resources/static-misc';
import { ENCODED_FILTER_SEL_PAR } from './filter-names.constants';

export const useEncodeFilters = (
  filterSelection: FilterSelectedValue[],
  trackRecentVisits: boolean,
) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const filterSelectionForEncode = useMemo(() => {
    const ret = filterSelection.filter(
      (i) => i && i.values && i.values.length > 0,
    );
    return ret;
  }, [filterSelection]);
  const encoded = useEncodeFilterSelection(filterSelectionForEncode);
  useEffect(() => {
    if (encoded && encoded.encoded) {
      searchParams.set(ENCODED_FILTER_SEL_PAR, encoded.encoded);
      setSearchParams(searchParams, { replace: true });
    }
    // No filter selected
    if (encoded === null) {
      searchParams.set(ENCODED_FILTER_SEL_PAR, '');
      setSearchParams(searchParams, { replace: true });
    }
  }, [encoded, setSearchParams, searchParams]);

  const location = useLocation();
  const path = useMemo(() => {
    if (location) {
      return location.pathname;
    } else {
      return '';
    }
  }, [location]);

  const storeKey = useAppFavouriteId(filterSelection, path, H_ID_PREFIX);
  const title = useAppFavouriteDefaultTitle(filterSelection);
  const { setSelectedValue } = useAppFavouriteValue(storeKey, H_LS_KEY);

  useEffect(() => {
    if (
      trackRecentVisits &&
      encoded &&
      encoded.encoded &&
      storeKey !== H_ID_PREFIX
    ) {
      const tags: FavouriteTag[] = PATH_TAGS[path];
      setSelectedValue({
        encoded: encoded.encoded,
        date: new Date(),
        id: storeKey,
        path,
        title,
        tags,
      });
      removeFavouteOlderList(H_LS_KEY);
    }
  }, [trackRecentVisits, encoded, setSelectedValue, storeKey, path, title]);
};
